import React, { Component } from "react";
import { Modal, Form, Col, Button, Card, Container, Row, Table } from "react-bootstrap";
import { Document, Page } from 'react-pdf';


class MaterialPDFViewModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            numPages: null,
        };
    }

    render() {
        console.log("pdff", this.props);
        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Materials pdf</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4" style={{
                    width: '100%',
                    height: '500px',
                    overflow: 'auto',
                }}>
                    <Row>
                        <Col sm={12}>
                            <Document
                                file={this.props.stateData?.individualMaterials[0]?.file_path}
                                onLoadSuccess={({ numPages }) => this.setState({ numPages })}
                            >
                                {Array.from(new Array(this.state.numPages), (el, index) => (
                                    <Page key={`page_${index + 1}`} pageNumber={index + 1} width={670} />
                                ))}
                            </Document>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

        )
    }
}
export default MaterialPDFViewModal;